
// @ts-nocheck
/* eslint-disable */
import { defineComponent, computed } from 'vue'
import {
  UPDATE_MODEL_EVENT,
  CHANGE_EVENT,
  BLUR_EVENT,
  FOCUS_EVENT,
} from '@/components/utils/constants'
import { label, useLabel } from '@/components/utils/label'
import {
  useValidate,
  validate,
  getValidationProps,
} from '@/components/utils/validate'
import ElSelect from '@/components/select'
import ElOption from '@/components/option'

interface Time {
  hours: number
  minutes: number
}
const parseTime = (time: string): null | Time => {
  const values = (time || '').split(':')
  if (values.length >= 2) {
    const hours = parseInt(values[0], 10)
    const minutes = parseInt(values[1], 10)
    return {
      hours,
      minutes,
    }
  }
  return null
}
const compareTime = (time1: string, time2: string): number => {
  const value1 = parseTime(time1)
  const value2 = parseTime(time2)
  const minutes1 = value1.minutes + value1.hours * 60
  const minutes2 = value2.minutes + value2.hours * 60
  if (minutes1 === minutes2) {
    return 0
  }
  return minutes1 > minutes2 ? 1 : -1
}
const formatTime = (time: Time): string => {
  return (
    (time.hours < 10 ? '0' + time.hours : time.hours) +
    ':' +
    (time.minutes < 10 ? '0' + time.minutes : time.minutes)
  )
}
const nextTime = (time: string, step: string): string => {
  const timeValue = parseTime(time)
  const stepValue = parseTime(step)
  const next = {
    hours: timeValue.hours,
    minutes: timeValue.minutes,
  }
  next.minutes += stepValue.minutes
  next.hours += stepValue.hours
  next.hours += Math.floor(next.minutes / 60)
  next.minutes = next.minutes % 60
  return formatTime(next)
}

export default defineComponent({
  name: 'MsTimeField',

  emits: [UPDATE_MODEL_EVENT, CHANGE_EVENT, BLUR_EVENT],

  mixins: [label, validate],

  components: { ElSelect, ElOption },

  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: '',
      validator: (value: string) =>
        !value || ['medium', 'small', 'mini'].indexOf(value) !== -1,
    },
    placeholder: {
      type: String,
      default: '',
    },
    start: {
      type: String,
      default: '09:00',
    },
    end: {
      type: String,
      default: '18:00',
    },
    step: {
      type: String,
      default: '00:30',
    },
    minTime: {
      type: String,
      default: '',
    },
    maxTime: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    prefixIcon: {
      type: String,
      default: 'el-icon-time',
    },
    clearIcon: {
      type: String,
      default: 'el-icon-circle-close',
    },
    allowCreate: {
      type: Boolean,
      default: true
    }
  },
  emits: ['change', 'blur', 'focus', 'update:modelValue'],

  setup(props, context) {
    const { labelCls, labelStyles } = useLabel(props)
    const validationObj = useValidate(props, context)
    const validationProps = getValidationProps(validationObj)

    const updateModel = (event) => {
      context.emit(UPDATE_MODEL_EVENT, event)
    }

    const onChange = (event) => {
      context.emit(CHANGE_EVENT, event)
    }

    const onBlur = (event) => {
      context.emit(BLUR_EVENT, event)
    }

    const onFocus = (event) => {
      context.emit(FOCUS_EVENT, event)
    }


    const validateCreate = (option): boolean => {
      const time: Time = parseTime(option.value)

      return time && isValidTime(time) && timeInRange(option.value)
    }

    const isValidTime = (time: Time): boolean => {
      // Max: 23:59
      return time.hours < 24 && time.minutes < 60
    }

    const timeInRange = (time: string): boolean => {
      // time >= min && time <= max
      return compareTime(time, props.start) >= 0 && compareTime(time, props.end) <= 0
    }

    // computed
    const value = computed(() => props.modelValue)
    const items = computed(() => {
      const result = []
      if (props.start && props.end && props.step) {
        let current = props.start
        while (compareTime(current, props.end) <= 0) {
          result.push({
            value: current,
            disabled:
              compareTime(current, props.minTime || '-1:-1') <= 0 ||
              compareTime(current, props.maxTime || '100:100') >= 0,
          })
          current = nextTime(current, props.step)
        }
      }

      return result
    })

    return {
      value,
      items,
      updateModel,
      onChange,
      validateCreate,
      onFocus,
      onBlur,
      labelCls,
      labelStyles,
      ...validationProps,
    }
  },

  computed: {
    cssCls() {
      const me = this

      return {
        'ms-time-field': true,
        'has-error': me.hasError,
        ...me.labelCls,
        [me.validateCls]: true,
      }
    },

    labelStyle() {
      return {
        ...this.labelStyles,
      }
    },
  },
})
